// FormField.js — The ONE label pattern for form inputs.
//
// Renders a 13px / 500-weight / gray-700 label ABOVE the input, with a red
// asterisk for required fields. Replaces MUI floating labels (legend-on-border)
// and placeholder-as-label everywhere.
//
// Usage:
//   <FormField label="Advance Amount (RM)" required error={errors.amount}>
//     <TextField fullWidth value={...} placeholder="e.g. 1,200.00" />
//   </FormField>
//
// Notes:
// - Do NOT pass `label` to the inner TextField/Select — FormField owns the label.
// - Placeholders on the inner input may only show example values ("e.g. ...").
// - Validation messages: pass `error` (string) or rely on the inner input's
//   own helperText when you need both error + hint text.
import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme/tokens';

export default function FormField({ label, required = false, error, children, sx = {}, labelAction = null }) {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography
            component="label"
            sx={{
              fontSize: tokens.typography.label.fontSize,
              fontWeight: tokens.typography.label.fontWeight,
              color: 'grey.700',
            }}
          >
            {label}
            {required && (
              <Box component="span" sx={{ color: 'error.main', ml: '2px' }}>
                *
              </Box>
            )}
          </Typography>
          {labelAction}
        </Box>
      )}
      {children}
      {error && (
        <Typography variant="caption" color="error.main" sx={{ display: 'block', mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}
